import React from 'react';
import { Box, Paper, IconButton, Typography } from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import { scroller } from "react-scroll";
import before_after from '../../assets/images/before_after.png';
import before_after_1 from '../../assets/images/before_after_1.png';


export const Gallery: React.FC = () => {
    const handleExpandClick = () => {
        scroller.scrollTo("contact", {
            duration: 1500,
            delay: 100,
            smooth: true,
        });
    };

    return (
        <Box
            id='gallery'
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'space-around',
                overflow: 'hidden',
                '& h4': {
                    fontFamily: 'Raleway',
                    textTransform: 'uppercase',
                    marginTop: '60px',
                },
            }}
        >
            <Typography variant='h4' sx={{ color: '#4a4a4a' }}>
                Gallery
            </Typography>
            <Box component="hr" sx={{ width: '40px', border: 0, borderTop: '2px solid #653A96', my: 1 }} />
            <Box sx={{ display: 'flex', justifyContent: 'center', alignContent: 'center', gap: 8, mt: 4, mb: 1, width: '100%', flexWrap: 'wrap' }}>
                <Paper elevation={3} sx={{ transition: 'all .2s ease-in-out', width: '575px', height: '920px', '&:hover': { transform: 'scale(1.08)' } }}>
                    <Box sx={{ width: '100%', textAlign: 'center' }}>
                        <img alt='before and after cleaning' src={before_after} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                    </Box>
                </Paper>
                <Paper elevation={3} sx={{ transition: 'all .2s ease-in-out', width: '575px', height: '920px', '&:hover': { transform: 'scale(1.08)' } }}>
                    <Box sx={{ width: '100%', textAlign: 'center' }}>
                        <img alt='before and after cleaning' src={before_after_1} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                    </Box>
                </Paper>
            </Box>

            <IconButton sx={{ mt: '20px', color: '#4a4a4a', zIndex: 2 }} onClick={handleExpandClick}>
                <ExpandMore fontSize="large" />
            </IconButton>
        </Box>
    );
}